/*DEFAULT GENERATED TEMPLATE. DO NOT CHANGE SELECTOR TEMPLATE_URL AND CLASS NAME*/
import { Component, OnInit, Input } from '@angular/core'

/**
* Model import Example : 
* import { HERO } from '../models/hero.model.ts';
*/

@Component({
    selector: 'bh-wiccardview',
    templateUrl: './wiccardview.template.html'
})

export class wiccardviewComponent implements OnInit {

    @Input() wicData: any = {};

    ngOnInit() {
        // console.log(this.wicData);
    }

    convertToTime(secs) {
        if (secs !== undefined && secs > 0) {
            const hours = Math.floor(secs / (60 * 60));

            const divisor_for_minutes = secs % (60 * 60);
            const minutes = Math.floor(divisor_for_minutes / 60);

            const divisor_for_seconds = divisor_for_minutes % 60;
            const seconds = Math.ceil(divisor_for_seconds);

            const time = this.padLeft(hours) + ':' + this.padLeft(minutes);
            return time;
        } else {
            return '00:00';
        }
    }

    padLeft = function (number) {
        if (number !== null && number !== undefined) {
            let str = '' + number;
            while (str.length < 2) {
                str = '0' + str;
            }
            return str;
        }
    }
    checkTimeCategory(time, name?) {
        const fiveMin = 300; // 5 * 60;
        const fifteenMin = 900; // 15 * 60;
        if (time || time == 0) {
            // time < 5min
            if (this.compareTime(time, fiveMin)) {
                return 'low';
            } else if (this.compareTime(fiveMin, time) && this.compareTime(time, fifteenMin)) { // 5min < number < 15min
                return 'medium';
            } else if (this.compareTime(fifteenMin, time)) { // > 15min
                return 'high';
            }
        }
        return null;
    }

    compareTime(time1: number, time2: number) {
        if (time1 <= time2) {
            return true;
        }
        return false;
    }

    /**
     * Format numeric time to HH:MM:SS format
     * @param timeNum numeric number either in minutes or seconds to be formatted
     * @param option string value either 'seconds' or 'minutes'. Invalid option returns null.
     */
    formatToTime(timeNum: number, option: string) {
        let formattedTime = '';
        switch (option) {
            case 'secs':
                formattedTime = this.formatToSeconds(timeNum);
                break;
            case 'mins':
                formattedTime = this.formatToMinutes(timeNum);
                break;
            default:
                return null;
        }
        return formattedTime;
    }

    private formatToSeconds(seconds) {
        const date = this.returnFirstDate();
        date.setSeconds(seconds);
        return this.returnTimeString(date);
    }

    private formatToMinutes(minutes) {
        const date = this.returnFirstDate();
        date.setMinutes(minutes);
        return this.returnTimeString(date);
    }

    private returnTimeString(dateString) {
        return dateString.toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
    }

    private returnFirstDate() {
        return new Date(1970, 0, 1);
    }
}



// WEBPACK FOOTER //
// C:/Neutrinos/mul-bhive-studio/multichoice/app/src/app/wiccardviewComponent/wiccardview.component.ts